import {
  clearToken,
  getRefreshToken,
  setToken,
} from '@/shared/utils/token.utils';
import { type ApolloClient } from '@apollo/client';
import {
  LogoutDocument,
  RefreshTokenDocument,
  type RefreshTokenMutation,
  type RefreshTokenMutationVariables,
} from '../api/__generated__';
import { showError } from '@drisk-ai/ui';

const handleRefreshTokenError = (client: ApolloClient) => {
  showError('Token expires');
  clearToken();
  client.query({
    query: LogoutDocument,
    variables: {
      input: {},
    },
  });
  window.location.reload();
};

export async function refreshToken(client: ApolloClient) {
  const refreshToken = getRefreshToken();

  if (!refreshToken) {
    handleRefreshTokenError(client);
    return;
  }

  try {
    const { data } = await client.mutate<
      RefreshTokenMutation,
      RefreshTokenMutationVariables
    >({
      mutation: RefreshTokenDocument,
      variables: {
        input: {
          refreshToken,
        },
      },
    });

    if (data?.refreshToken) {
      const accessToken = data.refreshToken.accessToken;
      const refreshToken = data.refreshToken.refreshToken;
      setToken(accessToken, refreshToken);

      return { accessToken, refreshToken };
    } else {
      throw new Error('Error while handling refresh token');
    }
  } catch {
    handleRefreshTokenError(client);
  }
}
